import { jwtDecode } from "jwt-decode";

const PROVIDER_ROLES = ["data_provider", "vocabulary_provider"];
const CONSUMER_ROLE = "data_consumer";
const ADMIN_REALM_ROLES = ["admin", "administrator"];
const ADMIN_MANAGEMENT_ROLES = ["view-realm", "manage-users"];

export function decodeTokenSafely(token) {
  if (!token || typeof token !== "string") {
    return null;
  }

  try {
    return jwtDecode(token);
  } catch (error) {
    console.warn("Unable to decode authentication token for connector routing.");
    return null;
  }
}

export function getTokenRoleSnapshot(token) {
  const decoded = decodeTokenSafely(token);
  const realmRoles = decoded?.realm_access?.roles || [];
  const managementRoles =
    decoded?.resource_access?.["realm-management"]?.roles || [];

  const isAdmin =
    ADMIN_REALM_ROLES.some((role) => realmRoles.includes(role)) ||
    ADMIN_MANAGEMENT_ROLES.some((role) => managementRoles.includes(role));

  const hasProviderRole = PROVIDER_ROLES.some((role) =>
    realmRoles.includes(role),
  );
  const isConsumerOnly = realmRoles.includes(CONSUMER_ROLE) && !hasProviderRole;

  return {
    decoded,
    realmRoles,
    managementRoles,
    isAdmin,
    hasProviderRole,
    isConsumerOnly,
  };
}

export function resolveConnectorServiceForSnapshot(snapshot, serviceName) {
  if (serviceName !== "springConnector") {
    return serviceName;
  }

  const { isAdmin, hasProviderRole, isConsumerOnly } = snapshot || {};

  if (isAdmin) {
    return "connectorMaster";
  }

  if (hasProviderRole) {
    return "springConnector";
  }

  if (isConsumerOnly) {
    return "connectorWorkerConsumer";
  }

  return "springConnector";
}

export function resolveConnectorServiceForToken(token, serviceName) {
  return resolveConnectorServiceForSnapshot(
    getTokenRoleSnapshot(token),
    serviceName,
  );
}
